/**
 * Payment Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageRequestDTO } from './pageRequestDTO';


export interface PaymentSearchParamsDTO { 
    tenantId?: number;
    orderCode?: string;
    status?: PaymentSearchParamsDTO.StatusEnum;
    pageRequest: PageRequestDTO;
}
export namespace PaymentSearchParamsDTO {
    export const StatusEnum = {
        Pending: 'PENDING',
        Settled: 'SETTLED',
        Failed: 'FAILED',
        Cancelled: 'CANCELLED',
        Refunded: 'REFUNDED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


